import React from 'react'
import {connect} from 'react-redux';
import UserModel from '/app/src/model/User/model';
import ConversationModel from '/app/src/model/Conversation/model';
import ConversationSelector from '/app/src/model/Conversation/selector'
import { toast } from 'react-toastify';
import {TextInput, Button, Flex} from '/app/src/component'

import style from './index.css'

class AssignedOptions extends React.Component {
    constructor(props)
    {
        super(props);
        this._renderResolveButton = this._renderResolveButton.bind(this);
        this._renderTransferButton = this._renderTransferButton.bind(this);
        this._sendConversation = this._sendConversation.bind(this);
        this.state = {
            openedSections: [],
            emailInput: '',
        }
    }

    __renderButton(onClick, text, imgSrc) {
        return (
            <Flex vAlignContent='center' height='65px' className={style.OptionButton} onClick={onClick}>
                <Flex marginLeft='25px' vAlignContent='center'>
                    <img src={imgSrc} className={style.buttonImg} alt=''/>
                    <p className={style.menuText}> {text} </p>
                </Flex>
            </Flex>
        )
    }

    _renderResolveButton(){
        let room = this.props.room;
        const onClick = () => this.props.dispatch(UserModel.resolveTicket(room));
        return this.__renderButton(onClick, 'Avklara ärende', '/images/ResolveButtonBlack.png')
    }

    __sectionClick(section){
        let isOpen = this.state.openedSections.indexOf(section);
        // if index is less than 0, it mean we need to open it
        if (isOpen < 0) {
            this.setState({ openedSections: [...this.state.openedSections, section] });
        }
        else {
            this.setState({ openedSections: this.state.openedSections.filter(sec => sec !== section) });
        }
    }

    _renderTransferButton(){
        let isOpen = this.state.openedSections.indexOf('transfer') >= 0;
        let coworkers = this.props.coworkers;
        let room = this.props.room;
        let renderCoworkerItems = 'Alla medarbetare är offline.'

        if(coworkers.size){
            renderCoworkerItems = coworkers.toList().map((co) => {
                    let email = co.get('email')
                    let name = co.get('name')
                    let img = co.get('image_url')
                    return (
                        <Flex
                            key={email}
                            onClick={() => {this.props.dispatch(UserModel.transferTicket(room, co.toJS(), this.props.customerDisplayName))}}
                            className={style.transferCoworkerItem}
                        >
                            <img className={style.onlineCoworkerImg} src={img ? img : '/images/anonymous-user.png'} width="34" height="34" alt='profile'/>
                            <Flex marginLeft='20px' column>
                                <Flex> {name} </Flex>
                                <Flex> {email} </Flex>
                            </Flex>

                         </Flex>
                    )
            })
        }

        const onClick = () => this.__sectionClick('transfer');
        return (
            <Flex column>
                {this.__renderButton(onClick, 'Överför ärende', '/images/TransferButtonBlack.png')}
                {isOpen &&
                    <Flex center column className={style.TransferCoworker}>
                        {renderCoworkerItems}
                    </Flex>
                }
            </Flex>
        )
    }

    _sendConversation(room, email) {
        ConversationModel.mailConversation(room, email)
        .end((err,res ) => {
            if (res.statusCode === 200) {
                toast('Chattkonversationen har skickats till ' + email)
            }
        })
    }

    _renderSendEmail(){
        let isOpen = this.state.openedSections.indexOf('email') >= 0;
        let renderEmailSection =  (
            <Flex marginTop='20px' hAlignContent='center'>
                <Flex basis='60%'>
                    <TextInput
                    value={this.state.emailInput}
                    onChange={ e => (this.setState({emailInput: e.target.value}))}
                    placeholder='Mottagarens email'
                    autoComplete='email'/>
                </Flex>
                <Flex marginLeft='20px' width='80px'>
                    <Button border className={style.SendButton} text={'Skicka'} onClick={() => this._sendConversation(this.props.room, this.state.emailInput)} size='fit'>Skicka</Button>
                </Flex>
            </Flex>
        )

        const onClick = () => this.__sectionClick('email')
        return (
            <Flex column>
                {this.__renderButton(onClick, 'Skicka som e-postmeddelande', '/images/Group 457.png')}
                {isOpen ?
                    <Flex className={style.TransferCoworker}>
                        {renderEmailSection}
                    </Flex>
                    : null
                }
            </Flex>
        )
    }

    render(){
        const isResolved = this.props.conversationResolved;

        return (
            <Flex column hAlignContent='center' className={style.Option} height='100%'>
                {!isResolved && this._renderResolveButton()}
                {!isResolved && this._renderTransferButton()}
                {this._renderSendEmail()}
            </Flex>
        )
    }
}

function mapStateToProps(state, props) {
    const conversation = ConversationSelector.getByRoom(state, props.room);
    const type = ConversationSelector.isResolved(conversation);
    let isResolved = false;

    if(type === 'resolved'){
        isResolved = true
    }

    const customerName = ConversationSelector.getCustomerName(conversation, null)
    const customerId = ConversationSelector.getCompanyCustomerId(conversation, null)
    let customerDisplayName = '<ID saknas>'
    if (customerName) customerDisplayName = `"${customerName}"`
    else if (customerId) customerDisplayName = `besökare #${customerId}`
    return {
        conversationResolved: isResolved,
        customerDisplayName: customerDisplayName
    }
}


export default connect(mapStateToProps, null)(AssignedOptions);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/Conversation/Assigned/Option.js